<div class="addContainer">
  <div *ngIf="memberArray" class="contact-details">
    <div class="modalHeader">
      <div class="contact-details-name mb-1">User Details</div>
      <button
        mat-icon-button
        (click)="dialogRef.close()"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div mat-dialog-content class="resource-dialog-content">
      <mat-card-content>
        <div class="row mt-1 details-grid">
          <!-- <div class="col-5 m-b-10">Member Number:</div>
          <div class="col-7 pro-left m-b-10">{{ memberArray.number }}</div> -->

          <div class="col-5 m-b-10">Firstname:</div>
          <div class="col-7 pro-left m-b-10">{{ memberArray.firstname }}</div>

          <div class="col-5 m-b-10">Lastname:</div>
          <div class="col-7 pro-left m-b-10">{{ memberArray.lastname }}</div>

          <div class="col-5 m-b-10">Phone Number:</div>
          <div class="col-7 pro-left m-b-10">{{ memberArray.phone }}</div>

          <div class="col-5 m-b-10">Staff ID:</div>
          <div class="col-7 pro-left m-b-10">{{ memberArray.staffId }}</div>

          <div class="col-5 m-b-10">Email:</div>
          <div class="col-7 pro-left m-b-10">{{ memberArray.email }}</div>

          <!-- <div class="col-5 m-b-10">D.O.B:</div>
          <div class="col-7 pro-left m-b-10">{{ memberArray.dob }}</div> -->

          <!-- <div class="col-5 m-b-10">Family:</div>
          <div class="col-7 pro-left m-b-10">{{ memberArray.family }}</div> -->
<!-- 
          <div class="col-5 m-b-10">Church:</div>
          <div class="col-7 pro-left m-b-10">{{ memberArray.church }}</div> -->

          <!-- <div class="col-5 m-b-10">Groups:</div>
          <div class="col-7 pro-left m-b-10">{{ memberArray.groups }}</div> -->

          <!-- <div class="col-5 m-b-10">Christian Community:</div>
          <div class="col-7 pro-left m-b-10">{{ memberArray.community }}</div> -->

          <div class="col-5 m-b-10">Created on:</div>
          <div class="col-7 pro-left m-b-10">
            {{ memberArray.postedTime }}
          </div>
          <!-- <div class="contact-details-name mb-1">Sacraments Details</div> -->

          <!-- <div class="col-5 m-b-10">Baptism</div> -->
          <!-- <div class="col-7 pro-left m-b-10">
            <span
              class="badge"
              [ngClass]="
                memberArray.isBaptised === true
                  ? 'badge-success'
                  : 'badge-danger'
              "
              [ngStyle]="{
                'background-color':
                  memberArray.isBaptised === true ? '#28a745' : '#dc3545',
                color: 'white',
                padding: '0.5rem 1rem',
                'border-radius': '0.25rem'
              }"
            >
              {{ memberArray.isBaptised === true ? "YES" : "NO" }}
            </span>
          </div> -->
          <!-- <div class="col-5 m-b-10">Holy Communion</div> -->
          <!-- <div class="col-7 pro-left m-b-10">
            <span
              class="badge"
              [ngClass]="
                memberArray.firstHolyCommunionFlag === true
                  ? 'badge-success'
                  : 'badge-danger'
              "
              [ngStyle]="{
                'background-color':
                  memberArray.firstHolyCommunionFlag === true
                    ? '#28a745'
                    : '#dc3545',
                color: 'white',
                padding: '0.5rem 1rem',
                'border-radius': '0.25rem'
              }"
            >
              {{ memberArray.firstHolyCommunionFlag === true ? "YES" : "NO" }}
            </span>
          </div> -->
          <!-- <div class="col-5 m-b-10">Confirmation</div> -->
          <!-- <div class="col-7 pro-left m-b-10">
            <span
              class="badge"
              [ngClass]="
                memberArray.confirmedFlag === true
                  ? 'badge-success'
                  : 'badge-danger'
              "
              [ngStyle]="{
                'background-color':
                  memberArray.confirmedFlag === true ? '#28a745' : '#dc3545',
                color: 'white',
                padding: '0.5rem 1rem',
                'border-radius': '0.25rem'
              }"
            >
              {{ memberArray.confirmedFlag === true ? "YES" : "NO" }}
            </span>
          </div> -->
          <!-- <div class="col-5 m-b-10">Holy Matrimony</div> -->
          <!-- <div class="col-7 pro-left m-b-10">
            <span
              class="badge"
              [ngClass]="
                memberArray.holyMatrimonyFlag === true
                  ? 'badge-success'
                  : 'badge-danger'
              "
              [ngStyle]="{
                'background-color':
                  memberArray.holyMatrimonyFlag === true
                    ? '#28a745'
                    : '#dc3545',
                color: 'white',
                padding: '0.5rem 1rem',
                'border-radius': '0.25rem'
              }"
            >
              {{ memberArray.holyMatrimonyFlag === true ? "YES" : "NO" }}
            </span>
          </div> -->

          <!-- <div class="col-5 m-b-10">Account Status:</div>
          <div class="col-7 pro-left m-b-10">
            <span
              class="badge"
              [ngClass]="
                memberArray.approved === 'Y' ? 'badge-success' : 'badge-danger'
              "
              [ngStyle]="{
                'background-color':
                  memberArray.approved === 'Y' ? '#28a745' : '#dc3545',
                color: 'white',
                padding: '0.5rem 1rem',
                'border-radius': '0.25rem'
              }"
            >
              {{ memberArray.approved === "Y" ? "approved" : "Inactive" }}
            </span>
          </div> -->
        </div>
      </mat-card-content>
    </div>
  </div>
</div>
